const options = {
  wrap: "flex-wrap",
  none: "flex-nowrap",
};

export default function getWrap(value) {
  return options[value];
}
